/**
 *
 * @module gpt
 * @description simplify working with doubleclick
 *
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(function (require, exports, module) {
            module.exports = factory(
                require('jquery'),
                require('bam.url/url'),
                require('ensureArray/ensureArray'),
                require('active-sponsorship/active-sponsorship')
            );
        });
    } else if (typeof exports === 'object') {
        module.exports = factory(
            require('jquery'),
            require('bam.url/url'),
            require('ensureArray/ensureArray'),
            require('active-sponsorship/active-sponsorship')
        );
    } else {
        root.bamDoubleclickGpt = factory(
            root.jQuery,
            root.bamUrl,
            root.bamEnsureArray,
            root.bamActiveSponsorship
        );
    }

}(this, function ($, url, ensureArray, activeSponsorship) {
    'use strict';

    var exports = {};
    var initialized = false;
    var DEFAULTS = {
        networkId: '/2605/',
        inventoryHierarchy: 'MiLB.com/',
        adUnitHierarchy1: 'MiLB.com',
        adUnitHierarchy2: '/test',
        adUnitHierarchy3: '',
        adUnitHierarchy4: '',
        adUnitHierarchy5: '',
        appView: 'web',
        skinElement: 'body',
        thresholds: [0, 568, 768, 1024, 1304],
        thresholdsMap: ['xs', 's', 'm', 'l', 'xl'],
        thresholdsMediaQueries: [
            window.matchMedia('(max-width: 567px)'),
            window.matchMedia('(min-width: 568px) and (max-width: 767px)'),
            window.matchMedia('(min-width: 768px) and (max-width: 1023px)'),
            window.matchMedia('(min-width: 1024px) and (max-width: 1303px)'),
            window.matchMedia('(min-width: 1304px)')
        ],
        targeting: {},
        initAdElementIds: [],
        slotOnloadHandler: $.noop,
        slotRenderedHandler: $.noop,
        slotVisibilityChangedHandler: $.noop,
        impressionViewableHandler: $.noop
    };

    var PREBID_TIMEOUT = 2500;
    var UNITNAME;
    var ADOPSTEST = url.Location().getParam('adtest');
    var $SKIN;
    var $HTML = $('html');
    var $RESPONSIVESLOTS = $('.ad-responsive-slot');
    var currentThreshold;
    var throttledMqlListener;
    var disableGPT = false;

    window.gptadslots = window.gptadslots || {};
    window.googletag = window.googletag || { cmd: [] };
    window.pbjs = window.pbjs || { que: [] };
    window.server_path.rubiconWrapperUrl = '//micro.rubiconproject.com/prebid/dynamic/8284.js';

    var isAppView = !!document.querySelector('.is-app');
    var bodyId = document.querySelector('BODY').getAttribute('id');
    const rubiconWhiteList = [
        'club-schedule_index',
        'forge-pagebuilder_index',
        'player_index',
        'roster_index',
        'roster_transactions',
        'scores_index',
        'standings_index',
        'stats_index',
        'tickets_tickets-near-you',
        'video_video',
    ];

    if (isAppView){
        var isDisableGPT = !!document.querySelector('.disableGPT');
        disableGPT = isDisableGPT ? false : true;
    }
    const enableRubicon = rubiconWhiteList.indexOf(bodyId) !== -1;

    if (enableRubicon) {
        /**
         * Prebid script loader on non-internal embed pages
         */
        (function () {
            var prebidJs = document.createElement('script');
            prebidJs.async = true;
            prebidJs.type = 'text/javascript';
            prebidJs.src = window.server_path.rubiconWrapperUrl;

            var firstScriptNode = document.getElementsByTagName('script')[0];
            firstScriptNode.parentNode.insertBefore(prebidJs, firstScriptNode);
        }());
    }

    if (!disableGPT) {
        /**
        * Google Publisher Tag script loader
        */
        (function () {
            var gptJs = document.createElement('script');
            gptJs.async = true;
            gptJs.type = 'text/javascript';
            gptJs.src = 'https://www.googletagservices.com/tag/js/gpt.js';
            var firstScriptNode = document.getElementsByTagName('script')[0];
            firstScriptNode.parentNode.insertBefore(gptJs, firstScriptNode);
        }());
    }

    /**
     *
     * @function setSponsoredOverlay
     * @description used to add 130x320 ad in on club sites from Out of Page ad
     * @param {Object} options - configured by Ad Ops.
     * @param {string} options.clickUrl - link url.
     * @param {string} options.creativeUrl - image url.
     *
     */
    window.setSponsoredOverlay = function (options) {

        var main = document.querySelector('main');
        var mainContainer = main.querySelector('.container');

        var sponsoredOverlay = document.createElement('div');
        sponsoredOverlay.className = 'p-ad__background-overlay';
        sponsoredOverlay.innerHTML = '<a href="' + options.clickUrl + '" target="_blank">' +
            '<img src="' + options.creativeUrl + '" border="0" alt="advertisement" />' +
            '</a>';

        mainContainer.insertBefore(sponsoredOverlay, mainContainer.childNodes[0]);

    };

    /**
     *
     * @function setTakeover
     * @param {Object} skin
     *
     */
    window.setTakeover = function (skin) {

        var bgColor = skin.bgColor || '#000000';
        var bgImage = (skin.bgImage) ? 'url(' + skin.bgImage + ')' : 'none';
        var bgPosition = skin.bgPosition || 'center top';
        var bgRepeat = skin.bgRepeat || 'no-repeat';
        var bgAttachment = skin.bgAttachment || 'scroll';

        $HTML.addClass('sponsored-takeover');

        $SKIN.css({
            'background-color': bgColor,
            'background-image': bgImage,
            'background-position': bgPosition,
            'background-repeat': bgRepeat,
            'background-attachment': bgAttachment
        });

        if (skin.clickHref) {

            var clickHref = skin.clickHref;
            var clickTarget = skin.clickTarget || '_blank';
            var clickHeight = skin.clickHeight || '900px';
            var clickTop = skin.clickTop || $SKIN.position().top || '0';

            // allow one instance of the sponsored takeover anchor
            if (!$HTML.find('#sponsored-takeover-link').length) {

                $('<a></a>').attr({
                    id: 'sponsored-takeover-link',
                    target: clickTarget,
                    href: clickHref
                }).css({
                    display: 'block',
                    position: 'absolute',
                    'z-index': '0',
                    width: '100%',
                    height: clickHeight,
                    top: clickTop
                }).prependTo($SKIN);

            }

        }

        $('#sidebar-takeover-news').insertAfter($('#sidebar-takeover-ad'));
        $('.club-bg-skin__link').remove();
    };

    /**
     *
     * @function triggerThresholdChangeEvent
     * @description fires the AD_THRESHOLD_CHANGE event
     *              updates the currentThreshold
     *
     */
    function triggerThresholdChangeEvent() {
        var previousThreshold = currentThreshold;
        var threshold = exports.getThreshold();
        currentThreshold = threshold;
    }

    /**
     *
     * @function handleThresholdChange
     * @description listener on each mql in DEFAULTS.thresholdsMediaQueries
     *              fires on every change in and out of a media query, so reduced to
     *              the mql event you're entering into and throttle the handler
     *
     */
    function handleThresholdChange(mql) {
        if (mql.matches) {
            clearTimeout(throttledMqlListener);

            throttledMqlListener = setTimeout(function () {

                if (mql.matches) {
                    exports.responsiveRefresh();
                }

            }, 500);
        }
    }

    /**
     *
     * @function getDefaultInventoryHierachy
     * @returns {String} inventoryHierachy
     *
     */
    function getDefaultInventoryHierachy() {

        var inventoryHierachy = DEFAULTS.networkId + DEFAULTS.adUnitHierarchy1;

        return inventoryHierachy;

    }


    /**
     *
     * @method getThreshold
     * @description returns the index of media query match from DEFAULTS.thresholdsMediaQueries array
     *
     */
    exports.getThreshold = function () {
        for (var i = 0; i < DEFAULTS.thresholdsMediaQueries.length; i++) {
            if (DEFAULTS.thresholdsMediaQueries[i].matches) {
                return i;
            }
        }
        return 0;
    };


    /**
     * @method responsiveRefresh
     * @description Refresh/display all ads that should be displayed at the current viewport
     * @param {Object} opts
     * @param {Object} [opts.skipContainers={}] A hashset of ad container IDs that shouldn't be re-targeted and re-displayed
     * @param {Object} [opts.responsiveSlots={}] A jQuery list of slots that can override the default $RESPONSIVESLOTS to be refreshed
     */
    exports.responsiveRefresh = function (opts) {
        currentThreshold = exports.getThreshold();
        opts = opts !== undefined ? opts : {};

        var skipContainers = opts.skipContainers || {};
        var refreshedSlots = [];

        exports.resetResponsiveSlots();

        var responsiveSlots = opts.responsiveSlots || $RESPONSIVESLOTS;

        responsiveSlots.each(function () {

            var $responsiveSlot = $(this);

            // Iterate through the ad size containers within, hide them all
            $responsiveSlot.find('.ad-responsive-size').hide().each(function () {

                var $responsiveSize = $(this);

                // Determine the thresholds/breakpoints this size should be displayed in
                var adThresholds = $responsiveSize.data('thresholds');
                var inThreshold = ($.inArray(currentThreshold, adThresholds) > -1);

                if (inThreshold) {

                    // Override the slots unitname if needed
                    var slotUnitname = UNITNAME;

                    if ($responsiveSlot.data('adunit')) {
                        slotUnitname = getDefaultInventoryHierachy() + $responsiveSlot.data('adunit');
                    }

                    slotUnitname += exports.adUnitFormFactor();

                    // Grab the Targeting params from the size and merge with the grouping's
                    var slotTargeting = $responsiveSlot.data('targeting');
                    var sizeTargeting = $responsiveSize.data('targeting');
                    var targeting = $.extend({}, slotTargeting, sizeTargeting);

                    // Grab the Container ID and Size Array for the Ad Slot
                    var container = $responsiveSize.attr('id');
                    var sizes = $responsiveSize.data('sizes');

                    if (skipContainers[container]) {

                        exports.unHide(container);

                    } else {

                        refreshedSlots.push(container);

                    }

                    // If this Ad Slot is not cached, defineSlot and setTargeting
                    if (!(container in window.gptadslots)) {

                        if ($responsiveSlot.hasClass('ad-outofpage')) {

                            exports.queue(function () {
                                window.gptadslots[container] = window.googletag.defineOutOfPageSlot(slotUnitname, container).addService(window.googletag.companionAds()).addService(window.googletag.pubads());
                            });

                        } else {

                            exports.queue(function () {
                                window.gptadslots[container] = window.googletag.defineSlot(slotUnitname, sizes, container).addService(window.googletag.companionAds()).addService(window.googletag.pubads());
                            });

                        }

                        exports.setTargeting(container, targeting);

                    // ad already exists in cache, update the targeting
                    } else {

                        exports.setTargeting(container, targeting);

                    }

                }

                return !inThreshold;

            });

        });

        exports.refresh(refreshedSlots);

    };


    /**
     * @method defineSlots
     * @description
     */
    exports.defineSlots = function () {

        currentThreshold = exports.getThreshold();

        exports.resetResponsiveSlots();

        // define the optional Out of Page slot, used for interstitials and takeovers
        if (DEFAULTS.hasOwnProperty('outOfPageAd')) {
            DEFAULTS.initAdElementIds.push(DEFAULTS.outOfPageAd.container);
            exports.defineOutOfPageSlot(DEFAULTS.outOfPageAd);
        }

        // define the ad slots passed to init config
        if (DEFAULTS.hasOwnProperty('ads')) {
            for (var def = 0; def < DEFAULTS.ads.length; def++) {
                DEFAULTS.initAdElementIds.push(DEFAULTS.ads[def].container);
                exports.defineSlot(DEFAULTS.ads[def]);
            }
        }

        $RESPONSIVESLOTS.each(function () {

            var $responsiveSlot = $(this);

            // Iterate through the ad size containers within, hide them all
            $responsiveSlot.find('.ad-responsive-size').hide().each(function () {

                var $responsiveSize = $(this);

                // Determine the thresholds/breakpoints this size should be displayed in
                var adThresholds = $responsiveSize.data('thresholds');
                var inThreshold = ($.inArray(currentThreshold, adThresholds) > -1);

                if (inThreshold) {

                    // Override the slots unitname if needed
                    var slotUnitname = UNITNAME;

                    if ($responsiveSlot.data('adunit')) {
                        slotUnitname = getDefaultInventoryHierachy() + $responsiveSlot.data('adunit');
                    }

                    slotUnitname += exports.adUnitFormFactor();

                    // Grab the Targeting params from the size and merge with the grouping's
                    var slotTargeting = $responsiveSlot.data('targeting');
                    var sizeTargeting = $responsiveSize.data('targeting');
                    var targeting = $.extend({}, slotTargeting, sizeTargeting);

                    // Grab the Container ID and Size Array for the Ad Slot
                    var container = $responsiveSize.attr('id');
                    var sizes = $responsiveSize.data('sizes');

                    // If this Ad Slot is not cached, defineSlot and setTargeting
                    if (!(container in window.gptadslots)) {

                        DEFAULTS.initAdElementIds.push(container);

                        if ($responsiveSlot.hasClass('ad-outofpage')) {

                            exports.queue(function () {
                                window.gptadslots[container] = window.googletag.defineOutOfPageSlot(slotUnitname, container).addService(window.googletag.companionAds()).addService(window.googletag.pubads());
                            });

                        } else {

                            exports.queue(function () {
                                window.gptadslots[container] = window.googletag.defineSlot(slotUnitname, sizes, container).addService(window.googletag.companionAds()).addService(window.googletag.pubads());
                            });

                        }

                        exports.setTargeting(container, targeting);

                    // ad already exists in cache, update the targeting
                    } else {

                        exports.setTargeting(container, targeting);

                    }

                }

                return !inThreshold;

            });

        });

    };

    /**
     * @method displaySlots
     * @description
     */
    exports.displaySlots = function () {


        for (var i = 0; i < DEFAULTS.initAdElementIds.length; i += 1) {
            exports.display(DEFAULTS.initAdElementIds[i]);
        }

    };


    /**
     *
     * @method destroySlots
     * @param {Array} slotIdsArr Array of ad containers
     * @description destroys the given slots, removing all related objects and references of those slots from GPT.
     * https://developers.google.com/doubleclick-gpt/reference#googletag.destroySlots
     *
     */
    exports.destroySlots = function(slotIds) {

        exports.queue(function() {
            if (slotIds && slotIds.length && slotIds.length > 0) {
                var slots = [];
                for(var i = 0; i < slotIds.length; i++) {
                    var gptAdSlot = window.gptadslots[slotIds[i]];
                    if (gptAdSlot) {
                        slots.push(gptAdSlot);
                        delete window.gptadslots[slotIds[i]];
                    }
                }
                window.googletag.destroySlots(slots);
            } else {
                window.googletag.destroySlots();
            }
        });

    };

    /**
     *
     * @method responsiveInit
     *
     */
    exports.responsiveInit = function () {

        currentThreshold = exports.getThreshold();
        exports.responsiveRefresh();

    };

    /**
     * @callback slotRenderedCallback
     * @param {event} googletag.events.SlotRenderEndedEvent
     * https://developers.google.com/doubleclick-gpt/reference#googletageventsslotrenderendedevent
     */

    /**
     * @method subscribeSlotRendered
     * @description Subscribe ads to the 'slotRenderEnded' event
     * @param {slotRenderedCallback} Callback function
     */
    exports.subscribeSlotRendered = function (cb) {

        window.googletag.pubads().addEventListener('slotRenderEnded', cb);

    };

    /**
     *
     * @method groupRefresh
     * @param {Array} ads
     * @description expects an Array of Objects, updates targeting and refreshes ad
     * @note display has to be called before refresh
     *
     */
    exports.groupRefresh = function (ads) {

        var collection = ensureArray(ads);
        var container;
        var targeting;

        for (var i = 0; i < collection.length; i += 1) {

            container = collection[i] && collection[i].container || '';
            targeting = collection[i] && collection[i].targeting || DEFAULTS.targeting;

            if (container in window.gptadslots) {

                exports.setTargeting(container, targeting);
                exports.display(container);
                exports.refresh(container);

            }

        }

    };

    /**
     *
     * @method queue
     * @param {Function} JsFunction
     *
     */
    exports.queue = function (JsFunction) {

        window.googletag.cmd.push(JsFunction);

    };

    /**
     *
     * @method defineOutOfPageSlot
     * @param {Object} outOfPageSlot
     *
     */
    exports.defineOutOfPageSlot = function (outOfPageSlot) {

        var container = outOfPageSlot.container;
        var targeting = outOfPageSlot.targeting;
        var slotUnit = UNITNAME;

        if (outOfPageSlot.inventoryHierarchy) {
            slotUnit = getDefaultInventoryHierachy() + outOfPageSlot.inventoryHierarchy;
        }

        slotUnit += exports.adUnitFormFactor();

        // If this Ad Slot is not cached, defineSlot
        if (!(container in window.gptadslots)) {

            exports.queue(function () {

                window.gptadslots[container] = window.googletag.defineOutOfPageSlot(slotUnit, container).addService(window.googletag.companionAds()).addService(window.googletag.pubads());

            });

        }

        exports.setTargeting(container, targeting);
    };

    /**
     *
     * @method defineSlot
     * @param {Object} slot
     *
     */
    exports.defineSlot = function (slot) {

        var container = slot.container;
        var sizes = slot.sizes;
        var targeting = slot.targeting;
        var slotUnit = UNITNAME;

        if (slot.inventoryHierarchy) {
            slotUnit = getDefaultInventoryHierachy() + slot.inventoryHierarchy;
        }

        slotUnit += exports.adUnitFormFactor();

        // If this Ad Slot is not cached, defineSlot
        if (!(container in window.gptadslots)) {

            exports.queue(function () {

                window.gptadslots[container] = window.googletag.defineSlot(slotUnit, sizes, container).addService(window.googletag.companionAds()).addService(window.googletag.pubads());

            });

        }

        exports.setTargeting(container, targeting);

    };

    /**
     *
     * @method defineAndDisplaySlot
     * @param {Object} slot
     *
     */
    exports.defineAndDisplaySlot = function (slot) {

        var container = slot.container;
        var sizes = slot.sizes;
        var slotUnit = UNITNAME;

        if (slot.inventoryHierarchy) {
            slotUnit = getDefaultInventoryHierachy() + slot.inventoryHierarchy;
        }

        slotUnit += exports.adUnitFormFactor();

        exports.queue(function () {

            window.gptadslots[container] = window.googletag.pubads().display(slotUnit, sizes, container);

        });

    };

    /**
     *
     * @method setPageTargeting
     * @param {Object} targeting
     *
     */
    exports.setPageTargeting = function (targeting) {

        exports.queue(function () {

            for (var key in targeting) {
                if (targeting.hasOwnProperty(key)) {

                    window.googletag.pubads().setTargeting(key, targeting[key]);

                }
            }

        });

    };

    /**
     *
     * @method setTargeting
     * @param {String} container
     * @param {Object} targeting
     * @description extends targeting Object with the required activeSponsorship Object,
     * passes data off to gptadslots
     *
     */
    exports.setTargeting = function (container, targeting) {

        currentThreshold = exports.getThreshold();

        exports.queue(function () {

            var pageWidthTargeting = {
                page_size: DEFAULTS.thresholdsMap[currentThreshold]
            };

            var slotTargeting = $.extend({}, targeting, pageWidthTargeting, activeSponsorship.adSlotTargeting(container));

            for (var key in slotTargeting) {
                if (slotTargeting.hasOwnProperty(key)) {

                    window.gptadslots[container].setTargeting(key, slotTargeting[key]);

                }
            }

        });

    };

    /**
     *
     * @method enableServices
     *
     */
    exports.enableServices = function () {

        exports.queue(function () {
            window.googletag.enableServices();
        });

    };

    /**
     *
     * @method unHide
     * @param {String} container
     *
     */
    exports.unHide = function (container) {

        document.getElementById(container).style.display = 'block';

    };

    /**
     *
     * @method display
     * @param {String} container
     *
     */
    exports.display = function (container) {

        exports.unHide(container);

        exports.queue(function () {
            window.googletag.display(container);
        });

    };

    /**
     *
     * @method refresh
     * @param {Array|String} ads
     *
     */
    exports.refresh = function (ads) {

        function contains(arr,obj) {
            return (arr.indexOf(obj) !== -1);
        }

        function filterAdSlots(elementIdArray) {
            return window.googletag.pubads().getSlots()
                .filter(function(slot) {
                    return contains(elementIdArray, slot.getSlotElementId());
                });
        }

        function getAuctionCallback() {
            var adserverRequestSent = false;
            var sendAdServerRequest = function(headerBiddingSlots) {
                if (adserverRequestSent) return;
                adserverRequestSent = true;
                window.googletag.pubads().refresh(headerBiddingSlots);
            };
            return sendAdServerRequest;
        }

        exports.queue(function() {
            var gptSlots = filterAdSlots(ensureArray(ads));
            if (gptSlots) {
                if (enableRubicon) {
                    exports.setPageTargeting({wrapper: 'dm'});
                }
                gptSlots.forEach(function (slot) {
                    window.googletag.display(slot);
                });
            }

            if (enableRubicon) {
                // callback function to send request
                var sendAdServerRequest = getAuctionCallback();
                // failsafe in case header pbjs doesn't fire
                setTimeout(function() {
                    sendAdServerRequest(gptSlots);
                }, PREBID_TIMEOUT);
                window.pbjs.que.push(function() {
                    window.pbjs.rp.requestBids({
                        callback: sendAdServerRequest,
                        gptSlotObjects: gptSlots
                    });
                });
            } else  if (!disableGPT) {
                window.googletag.pubads().refresh(gptSlots);
            }
        });
    };

    /**
     *
     * Reset the `$RESPONSIVESLOTS` variable.
     * Useful if slots are defined in lazy-loaded templates (ex. from an
     * external library).
     * @method resetResponsiveSlots
     *
     */
    exports.resetResponsiveSlots = function () {
        $RESPONSIVESLOTS = $('.ad-responsive-slot');
    };

    /**
     *
     * @method siteCoreConfig
     * @param {Object} config
     *
     */
    exports.siteCoreConfig = function (config) {
        $.extend(DEFAULTS, config);
    };

    /**
     *
     * @method adUnitFormFactor
     * @param {Object} config
     *
     */
    exports.adUnitFormFactor = function () {

        var adUnitHierarchyFormFactor = '';

        if (window.deviceBootstrap) {
            var formFactor = window.deviceBootstrap().formFactor;
            var platform = window.deviceBootstrap().platform;
            var isMobile = ['tablet', 'phone'].indexOf(formFactor) > -1;
            var isIosOrAndroid = ['ios', 'android'].indexOf(platform) > -1;

            adUnitHierarchyFormFactor += '/' + formFactor;
            if (isMobile) {
                adUnitHierarchyFormFactor += (isIosOrAndroid) ? '/' + platform : '/other';
            }
        }

        return adUnitHierarchyFormFactor;

    };

    /**
     *
     * Update the thresholdsMediaQueries array.
     * Called when custom thresholds are passed to config.
     *
     * @method updateMediaQueries
     *
     */
    exports.updateMediaQueries = function (thresholds) {
        for (var i = 0; i < thresholds.length; i++) {
            switch(i) {
                case 0:
                    DEFAULTS.thresholdsMediaQueries[i] = window.matchMedia(('(max-width: ' + (thresholds[i+1] - 1) + 'px)'));
                    break;
                case thresholds.length - 1:
                    DEFAULTS.thresholdsMediaQueries[i] = window.matchMedia('(min-width: ' + thresholds[i] + 'px)');
                    break;
                default:
                    DEFAULTS.thresholdsMediaQueries[i] = window.matchMedia(('(min-width: ' + thresholds[i] + 'px) and (max-width: ' + (thresholds[i+1] - 1) + 'px)' ));
            }
        }
        //remove any extra queries if custom set of thresholds is shorter than the default
        DEFAULTS.thresholdsMediaQueries = DEFAULTS.thresholdsMediaQueries.slice(0, thresholds.length);
    };

    /**
     * @method setPrebidTimeout
     * @description Set the timeout value for Prebid, defaults to 2500ms
     */
    exports.setPrebidTimeout = function(timeout) {
        PREBID_TIMEOUT = timeout;
    };

    /**
     * @method setInitialized
     * @description Set to true so if your page renders the AdsWrapper component multiple times on a page,
     * setting this to true would prevent multiple initialization
     */
    exports.setInitialized = function (initState) {
        initialized = initState;
    };

    /**
     *
     * @method init
     * @param {Object} config
     *
     */
    exports.init = function (config) {

        if (disableGPT || initialized) {
            return;
        }

        exports.siteCoreConfig(config);

        if (config.thresholds) {
            exports.updateMediaQueries(config.thresholds);
        }

        for (var i = 0; i < DEFAULTS.thresholdsMediaQueries.length; i++) {
            DEFAULTS.thresholdsMediaQueries[i].addListener(handleThresholdChange);
        }

        $SKIN = $(DEFAULTS.skinElement);

        UNITNAME = DEFAULTS.networkId + DEFAULTS.adUnitHierarchy1 + DEFAULTS.adUnitHierarchy2 + DEFAULTS.adUnitHierarchy3 + DEFAULTS.adUnitHierarchy4 + DEFAULTS.adUnitHierarchy5;

        exports.queue(function () {

            /*
            * The enableSingleRequest() method enables single request mode for fetching multiple ads at the same time.
            * This requires all pubads slots to be defined and added to the pubads service prior to enabling the service.
            * Single request mode must be set before the service is enabled.
            */
            window.googletag.pubads().enableSingleRequest();

            /*
            * The disableInitialLoad() method is optional for "auto-play" video
            * The method can prevent the scenario in which a display ad loads to the ad unit, but is displayed for only a few seconds
            before the video companion ad is delivered. Compare this with click-to-play ads, where it's not necessary to disable
            initial load because the display ad should show until the user clicks play, thus loading the companion.
            * Allows ads to be requested with a googletag.pubads().refresh() call.
            * This should be set prior to enabling the service. Async mode must be used; otherwise it will be impossible to request
            ads using refresh.
            */
            window.googletag.pubads().disableInitialLoad();

            /*
            * The collapseEmptyDivs() method sets whether the slot div should be hidden when there is no ad in the slot.
            * This overrides the service-level settings.
            */
            window.googletag.pubads().collapseEmptyDivs();

            /*
            * The setCentering(arg) method Enables/disables centering of ads.
            * This mode must be set before the service is enabled. Centering is disabled by default.
            * In legacy gpt_mobile.js, centering is enabled by default.
            */
            window.googletag.pubads().setCentering(true);

            /*
            * The slotOnload event is fired when the creative's iframe fires its load event.
            * When rendering rich media ads in sync rendering mode, no iframe is used so no SlotOnloadEvent will be fired.
            */
            window.googletag.pubads().addEventListener('slotOnload', DEFAULTS.slotOnloadHandler);

            /*
            * The slotRenderEnded event is fired when the creative code is injected into a slot.
            * This event will occur before the creative's resources are fetched, so the creative may not be visible yet.
            * The event is fired by the service that rendered the slot.
            * Example: To listen to companion ads, add a listener to the companion ads service, not the pubads service.
            * Note: If you need to know when the creative has fired its load event, consider the SlotOnloadEvent.
            */
            window.googletag.pubads().addEventListener('slotRenderEnded', DEFAULTS.slotRenderedHandler);

            /*
            * The slotVisibilityChanged event is fired whenever the on-screen percentage of an ad slot's area changes.
            * The event is throttled and will not fire more often than once every 200ms.
            */
            window.googletag.pubads().addEventListener('slotVisibilityChanged', DEFAULTS.slotVisibilityChangedHandler);

            /*
            * The impressionViewable event is fired when an impression becomes viewable, according to the Active View criteria.
            */
            window.googletag.pubads().addEventListener('impressionViewable', DEFAULTS.impressionViewableHandler);
        });

        // set the page level targeting
        if (DEFAULTS.hasOwnProperty('targeting')) {
            exports.setPageTargeting(DEFAULTS.targeting);
        }

        // adds query param ('adtest') driven key/val to all slots for testing
        if (!!ADOPSTEST) {
            exports.setPageTargeting({
                adtest: ADOPSTEST
            });
        }

        exports.defineSlots();

        exports.enableServices();

        exports.displaySlots();

        exports.refresh(DEFAULTS.initAdElementIds);

    };

    return exports;

}));
